import {Injectable} from '@angular/core';
import * as _ from 'lodash-es';
import {ImageClient} from '../../../client/image';
import {Config} from '../../config/config.service';

@Injectable()
export class ImageService {
  constructor(public imageClient: ImageClient, public config: Config) {
  }

  getAvatars(): string[] {
    let avatarList: string[] = [];

    const subscription = this.imageClient.getConfig().subscribe({
      next: result => avatarList = result,
      error: () => avatarList.push(this.config.CONFIG.imagesUrl + this.config.CONFIG.avatarImageFolder + this.config.CONFIG.defaultAvatarImage),
      complete: () => subscription.unsubscribe()
    });

    return avatarList;
  }

  createImageList(path: string, config: any): string[] {
    const imageList: string[] = [];

    _.times(config.total_items, index => imageList.push(this.constructImagePath(path, config, index)));

    return _.shuffle(imageList);
  }


  public constructImagePath(path: string, config: any, index: number): string {
    return `${this.ensureHttps(path)}${this.config.CONFIG.avatarImageFolder}${config.prefix}${index + 1}${config.suffix}`;
  }

  ensureHttps(url: string) {
    // Check if the URL starts with 'http://' or 'https://'
    if (!/^https?:\/\//i.test(url)) {
      // If not, prepend 'https://'
      return 'https:' + url;
    }
    // If it already has a protocol, return the URL as is
    return url;
  }

  async uploadImage(type?: any): Promise<any> {
    return null;
  }
}


// import {Injectable} from '@angular/core';
// import * as _ from 'lodash-es';
// import {ImageClient} from '../../../client/image';
// import {Config} from '../../config/config.service';
//
// const DEFAULT_AVATAR_IMAGE = '/images/useravatars/default.jpg';
//
// @Injectable()
// export class ImageService {
//     constructor(public imageClient: ImageClient, public config: Config) {
//     }
//
//     getAvatars(): string[] {
//         let avatarList: string[] = [];
//
//         const subscription = this.imageClient.getConfig().subscribe({
//             next: result => avatarList = result,
//             error: () => avatarList.push(this.config.CONFIG.imagesUrl + DEFAULT_AVATAR_IMAGE),
//             complete: () => subscription.unsubscribe()
//         });
//
//         return avatarList;
//     }
//
//     createImageList(path: string, config: any): string[] {
//         const imageList: string[] = [];
//
//         _.times(config.total_items, index => imageList.push(this.constructImagePath(path, config, index)));
//
//         return _.shuffle(imageList);
//     }
//
//     constructImagePath(path: string, config: any, index: number): string {
//         return `${this.ensureHttps(path)}/images/useravatars/${config.prefix}${index + 1}${config.suffix}`;
//     }
//
//     ensureHttps(url) {
//       // Check if the URL starts with 'http://' or 'https://'
//       if (!/^https?:\/\//i.test(url)) {
//         // If not, prepend 'https://'
//         return 'https:' + url;
//       }
//       // If it already has a protocol, return the URL as is
//       return url;
//     }
//
//     async uploadImage(type?: any): Promise<any> {
//         return null;
//     }
// }
